const configs = {
  apiURL: process.env.REACT_APP_API_URL,
  baseName: process.env.REACT_APP_BASENAME,
  socketURL: process.env.REACT_APP_SOCKET_URL,
  frontendURL: process.env.REACT_APP_FRONTEND_IE_URL,
};
export default configs;
